// BooleanFacet — tri-state: true | false | undefined (any).
// Used for things like "set-aside eligible for me" / "incumbent = us".

export interface BooleanFacetProps {
  field: string;
  label: string;
  value: boolean | undefined;
  onChange: (next: boolean | undefined) => void;
  trueLabel?: string;
  falseLabel?: string;
}

export function BooleanFacet({
  field,
  label,
  value,
  onChange,
  trueLabel = 'yes',
  falseLabel = 'no',
}: BooleanFacetProps) {
  const opts: { tag: string; label: string; selected: boolean; onClick: () => void }[] = [
    { tag: 'any', label: 'any', selected: value === undefined, onClick: () => onChange(undefined) },
    { tag: 'yes', label: trueLabel, selected: value === true, onClick: () => onChange(true) },
    { tag: 'no', label: falseLabel, selected: value === false, onClick: () => onChange(false) },
  ];
  return (
    <fieldset
      data-facet={field}
      style={{
        border: 'none',
        borderTop: '1px solid var(--bd)',
        margin: 0,
        padding: '8px 10px 10px',
      }}
    >
      <legend
        style={{
          padding: 0,
          color: 'var(--fg-3)',
          fontFamily: 'var(--mono)',
          fontSize: 10,
          letterSpacing: 0.4,
          textTransform: 'uppercase',
        }}
      >
        {label}
      </legend>
      <div role="radiogroup" style={{ marginTop: 6, display: 'flex', gap: 4 }}>
        {opts.map((o) => (
          <button
            key={o.tag}
            type="button"
            role="radio"
            aria-checked={o.selected}
            onClick={o.onClick}
            style={{
              flex: 1,
              height: 24,
              padding: '0 6px',
              background: o.selected
                ? 'var(--primary-soft, rgba(52,120,246,0.18))'
                : 'var(--bg-pane-2)',
              border: `1px solid ${o.selected ? 'var(--primary-line, rgba(52,120,246,0.45))' : 'var(--bd-strong)'}`,
              color: 'var(--fg-1)',
              fontFamily: 'var(--mono)',
              fontSize: 11,
              cursor: 'pointer',
            }}
          >
            {o.label}
          </button>
        ))}
      </div>
    </fieldset>
  );
}
